'use client';

import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { cn } from '@workspace/ui/lib/utils';

type Props = {
  open: boolean;
  children: ReactNode;
  isPost: boolean;
  onClose?: () => void;
};

export const Modal = ({ open, children, isPost, onClose }: Props) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  useEffect(() => {
    if (!open) return;
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  if (!mounted || !open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className={cn(
          'bg-white rounded-2xl shadow-lg flex flex-col overflow-y-auto overflow-x-hidden p-0',
          'w-[min(650px,calc(100vw-24px))] max-h-[80vh]',
          {
            'md:p-6 p-3': isPost,
          }
        )}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

